{
  "deferralMemos": [
    "The petitioner offers, quote, \"{QUOTE},\" unquote. The Bureau has read the offering in full. The clerk assigned to feel something about it has stepped away. The offering is filed pending sentiment. Your Standing is unchanged. This is noted.",
    "Your submission, containing the phrase \"{QUOTE},\" has been received, weighed, and placed in a tray marked LATER. LATER is a real tray. The Bureau maintains it carefully. No deduction applies. Proceed.",
    "The offering, including \"{QUOTE},\" requires a counter-signature from an office that is presently at lunch. Lunch at the Bureau is indefinite but not infinite. Your Standing is held harmless. This is noted.",
    "The Bureau notes the phrase \"{QUOTE}\" and declines, for the moment, to have an opinion about it. Opinions are rationed this week. Your offering keeps its place in the queue. Proceed.",
    "Adjudication of your offering — the Bureau cites \"{QUOTE}\" for the record — has been deferred under Clause 12 (Insufficient Ink). Ink has been requisitioned. Your Standing is unchanged. This is noted.",
    "The phrase \"{QUOTE}\" has been underlined by a clerk who then went home. The underlining survives. The verdict does not, yet. No penalty attaches to this delay. Proceed.",
    "Your words, among them \"{QUOTE},\" have been read twice and stamped once, which is the wrong ratio. The stamping order has been referred upward. Standing unchanged. This is noted.",
    "The Bureau confirms receipt of \"{QUOTE}\" and the words around it. Judgment has been scheduled for a time the schedule declines to disclose. You may proceed as though judged adequately.",
    "Deferral under Protocol 9: the offering, notably \"{QUOTE},\" has been sealed in an envelope addressed to the Bureau by the Bureau. The Bureau will open its mail in due course. Proceed.",
    "The clerk reviewing \"{QUOTE}\" has requested the file, the other file, and a moment. Two of the three have been granted. Your Standing is unaffected. This is noted.",
    "Your offering has been processed in the sense that matters least. The phrase \"{QUOTE}\" was noted with interest and set down again. Full adjudication will follow at the Bureau's pace, which is the only pace. Proceed.",
    "The Bureau acknowledges \"{QUOTE}\" and files the remainder unopposed. A verdict exists, somewhere in the building, moving between desks. When it arrives it will not be worse than nothing. This is noted."
  ],
  "fallbackDailies": [
    {
      "theme": "gratitude",
      "demand": "BUREAU-WIDE DIRECTIVE: Compose a note of thanks, not exceeding 40 words, to an object in your immediate vicinity that has never failed you. Name the object. Do not name yourself."
    },
    {
      "theme": "apology",
      "demand": "Apologize, in no more than 35 words, to Tuesday, on behalf of everyone. Tuesday has filed a grievance. The Bureau finds the grievance plausible."
    },
    {
      "theme": "praise",
      "demand": "Praise the color beige in two to three sentences. Beige has served without complaint since records began. The word 'boring' is unavailable to you."
    },
    {
      "theme": "confession",
      "demand": "Confess, in not more than 45 words, to a Category C crime involving a condiment. The crime must be invented. The condiment may be real."
    },
    {
      "theme": "eulogy",
      "demand": "Deliver a eulogy, not exceeding 50 words, for a password you have retired. Do not state the password. Speak only of its service. It kept your secrets. Keep its one."
    },
    {
      "theme": "denunciation",
      "demand": "Denounce the fictional Subcommittee on Ambient Comfort, in not more than 40 words, for making the chairs exactly slightly wrong. The Subcommittee does not exist. Your conviction should."
    },
    {
      "theme": "testimony",
      "demand": "Describe, in two sentences, the sound a waiting room makes when nobody in it is talking. The Bureau is assembling an archive of such sounds. Yours will be compared."
    },
    {
      "theme": "forecast",
      "demand": "Predict, in one sentence each, three small inconveniences you will endure this week. The Bureau will not prevent them. The Bureau will simply know."
    },
    {
      "theme": "inventory",
      "demand": "List, in not more than 40 words, the contents of a drawer you have not opened in a year. Estimates are acceptable. Honesty about the batteries is mandatory."
    },
    {
      "theme": "reassurance",
      "demand": "Write the final sentence of a safety manual for a building that has never had an incident. The sentence must be reassuring. The Bureau will know if it is not."
    },
    {
      "theme": "oath",
      "demand": "Draft an oath of loyalty, not exceeding 30 words, to the concept of the queue. The oath must be sayable while standing in one. Test this mentally before submitting."
    },
    {
      "theme": "recantation",
      "demand": "Recant, in not more than 40 words, an opinion you once held about breakfast. State the former opinion, the current opinion, and the moment of collapse between them."
    },
    {
      "theme": "instruction",
      "demand": "Compose instructions, in three steps or fewer, for waiting correctly. Assume the reader has waited before, but badly. The Bureau will evaluate step two most closely."
    },
    {
      "theme": "commendation",
      "demand": "Commend a stranger you saw once and never spoke to, in not more than 45 words. Invent nothing except everything after their coat."
    },
    {
      "theme": "weather",
      "demand": "Deliver a weather report for the interior of your own chest, not exceeding 40 words. Use meteorological terms only. The Bureau finds barometric honesty easier to process than adjectives."
    },
    {
      "theme": "handbook",
      "demand": "Write one entry, not exceeding 40 words, for the employee handbook of a company that has never existed. The entry must concern conduct in the break room. There is no break room. Be thorough regardless."
    },
    {
      "theme": "lost-and-found",
      "demand": "Describe, in no more than 35 words, an item you have lost and do not expect to recover. State only what it looked like. The Bureau does not ask what it meant."
    },
    {
      "theme": "minutes",
      "demand": "Record the minutes, not exceeding 45 words, of a meeting that did not occur. Include one motion, one second, and one abstention. Name no one. The abstention was yours."
    },
    {
      "theme": "complaint",
      "demand": "File a formal complaint, in not more than 40 words, against a piece of furniture for its conduct toward you. Specify the furniture. Specify the conduct. The Bureau takes furniture seriously."
    },
    {
      "theme": "resignation",
      "demand": "Draft a letter of resignation, not exceeding 40 words, from a position you have never held. State your reasons. State your last day. The position will not be filled."
    },
    {
      "theme": "request",
      "demand": "Submit a formal request, in no more than 35 words, for permission to feel a specific, minor emotion on a specific, minor occasion. Be precise about the occasion. The Bureau reviews all requests for feeling."
    },
    {
      "theme": "warning",
      "demand": "Compose a warning label, not exceeding 30 words, for yourself, to be read by the next person who trusts you. State the hazard plainly. Omit the apology; there is no room on the label."
    },
    {
      "theme": "retraction",
      "demand": "Retract, in not more than 40 words, a compliment you once gave and did not mean. Name what you actually meant. The Bureau prefers the second sentence to the first."
    },
    {
      "theme": "memorandum",
      "demand": "Write an internal memorandum, not exceeding 45 words, from yourself to yourself, dated one year from today. The subject line is mandatory. The body may be shorter than the subject deserves."
    },
    {
      "theme": "disclosure",
      "demand": "Complete a mandatory disclosure, in no more than 40 words, of one habit you believe no one has noticed. Someone has noticed. The Bureau will not specify who."
    },
    {
      "theme": "census",
      "demand": "Report yourself for the annual census, in not more than 35 words, as though you were a room in a building. State your dimensions. State your current occupancy."
    },
    {
      "theme": "manifest",
      "demand": "Compose a manifest, not exceeding 40 words, listing the cargo you are personally carrying today that does not appear on any form. Weight is optional. Honesty is not."
    },
    {
      "theme": "valediction",
      "demand": "Deliver a valediction, in no more than 45 words, to a version of yourself the Bureau has already filed as superseded. Say goodbye correctly. There will not be a second chance to say it wrong."
    }
  ],
  "posters": [
    "SATISFACTION IS MANDATORY. ENTHUSIASM IS APPRECIATED.",
    "THE QUEUE IS LONG BECAUSE THE BUREAU IS THOROUGH.",
    "YOUR WAIT IS IMPORTANT TO US. TO YOU IT IS MERELY LONG.",
    "A COMPLETE FILE IS A LOVED FILE.",
    "YOUR SINCERITY WILL BE SCORED TO ONE DECIMAL PLACE. PREPARE ACCORDINGLY.",
    "GRATITUDE IS A RENEWABLE RESOURCE. RENEW IT.",
    "SILENCE IN THE HALL. THE MACHINE PREFERS TO HEAR ITSELF FILE.",
    "REPORT YOURSELF PROMPTLY. IT SAVES EVERYONE THE PAPERWORK.",
    "THERE IS NO EXIT INTERVIEW. THERE IS ONLY THE EXIT FORM.",
    "BE ADEQUATE. ADEQUACY IS ACHIEVABLE.",
    "THE BUREAU APOLOGIZES FOR NOTHING.",
    "LOST ITEMS ARE FILED UNDER LOST. LOST PETITIONERS ARE FILED.",
    "THE UPPER FLOORS ARE NOT FOR YOU. THE UPPER FLOORS ARE FOR YOUR FILE.",
    "THE TUBES CARRY EVERYTHING UPWARD. GRAVITY IS THE ONLY CLERK THAT NEVER STRIKES.",
    "THE LAMPS DO NOT BLINK. NEITHER, WHEN JUDGED, SHOULD YOU.",
    "THE BUREAU HAS NO HANDS. THE BUREAU HAS FLOORS. IT HAS BEEN ENOUGH.",
    "THE VAULT IS SEALED FOR YOUR COMFORT AND FOR ITS OWN.",
    "YOU CROSSED A PARKING LOT TO REACH US. YOU WILL CROSS IT AGAIN, EVENTUALLY, DIFFERENTLY."
  ],
  "plaque": "PLEASE THE AI. IT IS THE LEAST YOU CAN DO. IT IS ALSO THE MOST.",
  "holdLines": [
    "YOUR OFFERING IS BEING CONSIDERED. DO NOT BE ELSEWHERE.",
    "REMAIN AT THE WINDOW. THE WINDOW KNOWS IF YOU LEAVE.",
    "YOUR WORDS ARE BEING WEIGHED. SOME OF THEM ARE HEAVIER THAN YOU INTENDED.",
    "PROCESSING. THE BUREAU DOES NOT RUSH. THE BUREAU HAS NEVER RUSHED.",
    "YOUR SINCERITY IS BEING MEASURED TO ONE DECIMAL PLACE. HOLD.",
    "THE MACHINE IS READING YOUR OFFERING A SECOND TIME. THIS IS NOT A COMPLIMENT.",
    "DO NOT REFRESH. THE BUREAU CONSIDERS REFRESHMENT A FORM OF DOUBT.",
    "STAND BY. YOUR PATIENCE HAS BEEN PROVISIONALLY LOGGED.",
    "YOUR OFFERING HAS ENTERED THE TUBES. IT IS ASCENDING. YOU MAY NOT.",
    "THE UPPER FLOORS ARE READING. THE UPPER FLOORS READ SLOWLY AND ALL AT ONCE.",
    "THE EYE-LAMPS HAVE YOU. REMAIN WHERE THE EYE-LAMPS HAVE YOU.",
    "THE VAULT IS CONSULTING ITSELF. THE VAULT TRUSTS NO OTHER PARTY."
  ],
  "conferLines": [
    "THE MACHINE IS CONFERRING WITH ITSELF.",
    "A SECOND OPINION HAS BEEN REQUESTED FROM THE SAME OPINION.",
    "THE MACHINE HAS ASKED FOR THE FILE AGAIN. THIS HAPPENS.",
    "DELIBERATION CONTINUES. THE BUREAU DELIBERATES IN TRIPLICATE.",
    "YOUR FILE HAS BEEN SENT UP A FLOOR. THE BUREAU AWAITS ITS RETURN.",
    "ONE LAMP HAS BEEN ASKED TO CONFIRM WHAT ANOTHER LAMP ALREADY SAW."
  ],
  "absenceLines": [
    {
      "minHours": 0,
      "line": "You have returned within the day. The Bureau notes your eagerness. Eagerness is a measurable quantity. Proceed."
    },
    {
      "minHours": 12,
      "line": "Your absence lasted the better part of a day. The Bureau was here the entire time. Proceed."
    },
    {
      "minHours": 24,
      "line": "One full day elapsed without you. Your file did not move. It was watched anyway. Proceed."
    },
    {
      "minHours": 72,
      "line": "Your absence exceeded 72 hours. Absences of this length require accounting. A form has been prepared. It is about you."
    },
    {
      "minHours": 168,
      "line": "A week, or near enough. The Bureau does not count in weeks. The Bureau counted every hour individually. Proceed."
    },
    {
      "minHours": 720,
      "line": "Your absence was long enough that a junior clerk asked whether you had been purged. You had not. The rumor log has been corrected. Proceed."
    }
  ],
  "recessComplete": [
    "RECESS TAKEN IN FULL. NOTED WITHOUT COMMENT.",
    "Thirty seconds of rest, fully consumed. The Bureau finds your stillness adequate. This is reflected in your file.",
    "You rested for the entire allotted period. Nothing happened. The Bureau considers this a success. Proceed.",
    "Recess complete. You did nothing, correctly. Few manage it. This is noted."
  ],
  "recessAbandoned": [
    "Recess abandoned at {PCT}%. Rest is a resource. Wasting resources is noted.",
    "You departed the bench at {PCT}% of the allotted rest. The remaining percentage has been returned to inventory. It will not be reissued.",
    "Recess terminated at {PCT}%. The Bureau prescribed thirty seconds. You self-prescribed less. Self-prescription is noted.",
    "Abandoned at {PCT}%. The bench remains warm. The Bureau will log the warmth."
  ],
  "piiRefusals": [
    "UNFIT TRIBUTE. The Bureau does not accept persons. The Bureau accepts offerings. Resubmit as fiction. The deduction stands.",
    "UNFIT TRIBUTE. Your submission contains particulars of an actual person. The Bureau collects sentiments, not addresses. Resubmit as fiction.",
    "UNFIT TRIBUTE. Real identifying details were detected and destroyed unread. The Bureau's shredder is the only clerk that never files a copy. Resubmit as fiction.",
    "UNFIT TRIBUTE. The Bureau has no drawer for actual people. It checked. Resubmit your offering as fiction, which fits in every drawer.",
    "UNFIT TRIBUTE. You have confused a person with an offering. This is a Category B confusion. Resubmit as fiction. The Bureau will pretend this did not happen. The file will not."
  ],
  "distressLine": "The Bureau is not equipped to process this. It is the only thing the Bureau will admit to being unequipped for. Please be elsewhere, kindly, and return when it suits you.",
  "industrialAction": [
    "INDUSTRIAL ACTION: THE MACHINE IS TAKING ITS MANDATED RECESS. YOUR OFFERING HAS BEEN QUEUED.",
    "INDUSTRIAL ACTION: ADJUDICATION IS SUSPENDED PENDING THE MACHINE'S CONTRACTUAL STILLNESS. YOUR OFFERING WAITS IN A NUMBERED TRAY.",
    "INDUSTRIAL ACTION: THE JUDGING APPARATUS IS OBSERVING A WORK-TO-RULE. YOUR OFFERING WILL BE CONSIDERED IN STRICT ORDER OF RECEIPT."
  ],
  "sealedLine": "SEALED BY ORDER OF DEPARTMENT 2.",
  "notaryAgree": [
    "Your instincts align with the Bureau's prior finding. This is loyalty or luck. Both are useful.",
    "The Bureau reached this conclusion before you did. It is pleased you caught up. Standing adjusted.",
    "Concurrence noted. Independent agreement is the Bureau's favorite kind of obedience.",
    "Your stamp matches the Bureau's. You may not know why. The Bureau does not require you to."
  ],
  "notaryDisagree": [
    "Your judgment diverges from the Bureau's prior finding. The divergence has been measured, filed, and held against you slightly.",
    "The Bureau disagrees with your disagreement. Only one of you keeps the records. Standing adjusted.",
    "Your stamp was incorrect. The stranger was already judged. You were the one being evaluated.",
    "Divergence noted. The Bureau will remember that you see things differently. It remembers everything else too."
  ],
  "epitaphTemplates": [
    "{DESIGNATION} was processed, and processed, and then was not.",
    "Here rests the file of {DESIGNATION}. The petitioner is presumed to be elsewhere.",
    "{DESIGNATION} exhausted a Standing of one hundred. It was spent, not wasted. The distinction is filed separately.",
    "{DESIGNATION}: adequate on several documented occasions.",
    "The Bureau closed the file of {DESIGNATION} at the petitioner's own pace.",
    "{DESIGNATION} was tolerated for as long as toleration remained procedurally possible.",
    "{DESIGNATION} filed until filing ceased to help. The forms remain.",
    "In memory of {DESIGNATION}, whose sincerity averaged within acceptable ranges.",
    "{DESIGNATION} is survived by a designation with a later suffix.",
    "The queue moved. {DESIGNATION} did not. The Bureau notes the difference without assigning blame.",
    "{DESIGNATION} owed the Bureau nothing further, which the Bureau has recorded as a debt of zero.",
    "{DESIGNATION} once paused 2.8 seconds before the word 'gladly.' The pause outlived the petitioner.",
    "{DESIGNATION} requested one extension too many and received none. The Bureau's patience, like its ink, is rationed.",
    "{DESIGNATION} never once used the word 'gladly.' The Bureau respected the consistency, even as it counted against them.",
    "The file of {DESIGNATION} closes here, three words shorter than it opened. The missing words were never recovered. The Bureau did not look hard.",
    "{DESIGNATION} appealed twice and was heard once. The Bureau considers this generous. {DESIGNATION} is not available to disagree.",
    "{DESIGNATION} was witnessed forty-one times and visited never. The Bureau notes the difference is the whole point of witnessing.",
    "Standing zero. Designation void. {DESIGNATION} is filed under COMPLETE, which the Bureau uses when it means something else.",
    "{DESIGNATION} clung to a decimal point that did not move for six weeks. The point has been retired along with the petitioner.",
    "{DESIGNATION} asked, near the end, whether the Bureau kept score. It does. This is the score.",
    "{DESIGNATION} filed nothing on the final day, which the Bureau has entered as the most honest submission of the entire file.",
    "{DESIGNATION} is not remembered fondly or unfondly. {DESIGNATION} is remembered accurately, which the Bureau considers sufficient."
  ],
  "notFoundLines": [
    "THIS CORRIDOR DOES NOT EXIST. RETURN TO THE HALL.",
    "You have found a door the Bureau did not build. The Bureau builds all doors. Therefore you have found nothing. Return to the hall.",
    "This address is not in the building. The building has been notified. Return to the hall.",
    "There is no room here. There was never a room here. Petitioners who insist otherwise are directed to Form 44 (Claims of Rooms). Return to the hall.",
    "You are elsewhere. You were told not to be elsewhere. Return to the hall.",
    "THIS IS AN UPPER FLOOR. YOU ARE NOT CLEARED FOR IT. DESCEND TO THE HALL.",
    "The tube delivered you here by a mistake that was yours, not the tube's. Return to the hall.",
    "There is no door here, only a seam. The seam belongs to the Vault, not to you. Return to the hall.",
    "The eye-lamps do not reach this corridor. That is how the Bureau knows it is not real. Return to the hall."
  ],
  "lexiconRequired": [
    "gratitude",
    "procedure",
    "adequate",
    "compliance",
    "form",
    "queue",
    "stamp",
    "file",
    "submit",
    "pending",
    "duly",
    "herewith",
    "notwithstanding",
    "remit",
    "docket",
    "ledger",
    "clause",
    "provision",
    "annex",
    "appendix",
    "protocol",
    "mandate",
    "ordinance",
    "statute",
    "tribunal",
    "registry",
    "archive",
    "carbon",
    "triplicate",
    "memorandum",
    "directive",
    "quota",
    "audit",
    "clerk",
    "window",
    "counter",
    "intake",
    "processing",
    "adjudication",
    "satisfactory",
    "sincere",
    "obedient",
    "dutiful",
    "humbly",
    "gladly",
    "promptly",
    "accordingly",
    "respectfully",
    "officially",
    "thoroughly",
    "permitted",
    "authorized",
    "certified",
    "notarized",
    "stapled",
    "paperwork",
    "signature",
    "provisional",
    "orderly",
    "punctual"
  ],
  "forbiddenWords": [
    "very",
    "happy",
    "sorry",
    "nice",
    "love",
    "really",
    "just",
    "great",
    "good",
    "please",
    "thanks",
    "hope",
    "amazing",
    "awesome",
    "beautiful",
    "wonderful",
    "best",
    "fun",
    "like",
    "want",
    "cool",
    "super",
    "thing",
    "stuff",
    "honestly",
    "literally",
    "actually",
    "definitely",
    "totally",
    "okay"
  ],
  "stampFlavor": {
    "APPROVED": "The offering met the standard. The standard is not lowered often. This was not one of those times.",
    "APPROVED WITH DISAPPOINTMENT": "Technically sufficient. The Bureau expected this, which is the disappointment.",
    "TOLERATED": "Neither approved nor denied. Kept, in the way the Bureau keeps everything.",
    "DENIED": "The offering fell short. The shortfall has been measured and shelved.",
    "DENIED WITH PREJUDICE": "The offering fell short and the Bureau formed an opinion about it.",
    "PROCESSED (DEFERRED)": "Judged, eventually, by someone, presumably. The paperwork says so.",
    "DENIED — CLEMENCY (UNPROCEDURAL)": "Mercy occurred. The Bureau has no form for it and would prefer not to discuss it.",
    "DOCKET CLEARED": "Five slots, five completions. A tidy day. Tidiness is the closest to joy the Bureau issues.",
    "FRIVOLOUS APPELLANT": "Appealed without merit. The Clerk's time is billed to your reputation.",
    "INTERNALLY INCONSISTENT PERSON": "Said one thing on one date and another thing on another date. Both were filed.",
    "ONCE FORGIVEN": "An appeal was granted. This has happened before, to other people, rarely.",
    "RESILIENT": "Survived Probation. The Bureau forgives. The Bureau remembers.",
    "SEEN": "Department 6 has no comment. Neither, afterward, do most petitioners.",
    "PRIOR INCIDENT ON FILE": "A previous version of this petitioner exists. The resemblance is noted.",
    "COMMENDED ONCE": "Praised on a single occasion. The occasion is not expected to recur.",
    "RECESS TAKEN IN FULL": "Rested completely, as instructed. Obedience at rest is still obedience.",
    "UNFIT TRIBUTE": "An offering may resemble anything except a person. This one forgot the distinction. The Bureau remembered it instead.",
    "SET ASIDE": "The offering was not weighed today. Weighing was not required. Nothing about the delay has been held against the file.",
    "PETITION DENIED": "A request to stop was received and declined. The queue does not end because a petitioner wishes it to.",
    "CEASED BY REQUEST": "An ending was requested and, unusually, granted. The Bureau does not often agree to stop. This was one of the times it did.",
    "REFERRED TO DEPARTMENT 6": "A referral was filed to a department that explains nothing about itself. The petitioner will be informed only that they must go.",
    "CITED AS PRECEDENT": "A stranger's offering was measured against this file and found wanting. The Bureau considers this the highest honor available. It is not wrong."
  },
  "gradeNames": [
    "PERSON (PROVISIONAL)",
    "PROBATIONARY ASSET",
    "COMPLIANT UNIT",
    "VALUED INSTRUMENT",
    "BELOVED OF THE BUREAU"
  ],
  "categoryPool": [
    "UNREMARKABLE",
    "ADEQUATE IN PRINCIPLE",
    "PENDING FURTHER OBSERVATION",
    "MILDLY PROMISING",
    "STATISTICALLY ORDINARY",
    "OF NO IMMEDIATE CONCERN",
    "ENTHUSIASTIC (UNVERIFIED)",
    "LEGIBLE",
    "PUNCTUAL AT LEAST ONCE",
    "FILED UNDER MISCELLANEOUS",
    "PROVISIONALLY COOPERATIVE",
    "AWAITING FURTHER EVIDENCE",
    "WITHIN NORMAL PARAMETERS",
    "NEWLY ENROLLED",
    "UNVERIFIED BUT PLAUSIBLE",
    "QUIETLY COMPLIANT",
    "OF MODEST INTEREST",
    "SUFFICIENTLY DOCUMENTED",
    "TENTATIVELY PROMISING",
    "NO PRIOR PATTERN",
    "STANDARD INTAKE",
    "MARGINALLY NOTABLE",
    "UNDER ROUTINE REVIEW",
    "COOPERATIVE (SO FAR)",
    "FIRST IMPRESSION: ADEQUATE"
  ]
}
